import {ValueObject} from '@s-ui/domain'

export class LeadHitTrackingValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.hitId
   **/
}
